/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, {
  useState, useEffect, useMemo, useRef,
} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { VariableSizeList as List } from 'react-window';

import Text from '../../../../shared/components/Text/Text';
import { showErrorToast } from '../../../../shared/utils/toastManager';
import {
  createParentCalendar,
  createParentChildCalendar,
  createSavedWorkout,
  setCreateModalProgramType,
  setProgramType,
  fetchSavedWorkouts,
  createProgramTag,
} from '../../ducks/calendarActions';
import SelectBox from '../../../../shared/_TBComponents/SelectBox';

const Container = styled('div')`
  width: 100%;
  margin: 0 auto;
  padding: ${(props) => (props.isModal ? '20px' : '100px 20px')};
  background: white;
  min-height: ${(props) => (props.isModal ? 'auto' : '100vh')};

  @media (max-width: 768px) {
    padding: ${(props) => (props.isModal ? '16px' : '60px 16px')};
  }

  @media (max-width: 480px) {
    padding: ${(props) => (props.isModal ? '12px' : '40px 12px')};
  }
`;

const ContentWrapper = styled('div')`
  max-width: ${(props) => (props.isModal ? '100%' : '800px')};
  min-width: ${(props) => (props.isModal ? 'unset' : '700px')};
  margin: 0 auto;
  width: 100%;

  @media (max-width: 768px) {
    min-width: unset;
    max-width: 100%;
  }
`;

const Breadcrumbs = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  color: #999;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 16px;
  }
`;

const BreadcrumbSeparator = styled('span')`
  margin: 0 8px;
  color: #ccc;
`;

const BreadcrumbButton = styled('button')`
  background: none;
  border: none;
  padding: 0;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.disabled ? '#aaa' : '#999')};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  text-decoration: none;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

  &:hover {
    text-decoration: ${(props) => (props.disabled ? 'none' : 'underline')};
  }

  &:focus {
    outline: ${(props) => (props.disabled ? 'none' : '2px solid #4A90E2')};
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

const Title = styled('h1')`
  font-family: 'Nunito Sans';
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

const Subtitle = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  color: #666;
  margin: 0 0 40px 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 14px;
    margin: 0 0 32px 0;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    margin: 0 0 24px 0;
  }
`;

const FormGroup = styled('div')`
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 16px;
  }
`;

const Label = styled('label')`
  display: block;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  
  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  @media (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 4px;
  }
`;

const Input = styled('input')`
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: 'Nunito Sans';
  font-size: 16px;
  color: #333;
  
  &::placeholder {
    color: #bbb;
  }
  
  &:focus {
    outline: none;
    border-color: #666;
  }
  
  @media (max-width: 768px) {
    padding: 10px 14px;
    font-size: 16px; /* Keep 16px to prevent zoom on iOS */
  }
  
  @media (max-width: 480px) {
    padding: 8px 12px;
  }
`;

const SelectContainer = styled('div')`
  .react-select__control {
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 44px;
    box-shadow: none;
    font-family: 'Nunito Sans';

    &:hover {
      border-color: #666;
    }
    
    @media (max-width: 768px) {
      min-height: 48px; /* Larger touch target */
    }
  }

  .react-select__control--is-focused {
    border-color: #666;
    box-shadow: none;
  }

  .react-select__value-container {
    padding: 8px 16px;
    
    @media (max-width: 768px) {
      padding: 10px 14px;
    }
    
    @media (max-width: 480px) {
      padding: 8px 12px;
    }
  }

  .react-select__single-value {
    color: #333;
    font-family: 'Nunito Sans';
    font-size: 16px;
    
    @media (max-width: 768px) {
      font-size: 16px; /* Keep 16px to prevent zoom on iOS */
    }
  }

  .react-select__placeholder {
    color: #bbb;
    font-family: 'Nunito Sans';
    font-size: 16px;
    
    @media (max-width: 768px) {
      font-size: 16px; /* Keep 16px to prevent zoom on iOS */
    }
  }

  .react-select__menu {
    border: none;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .react-select__option {
    font-family: 'Nunito Sans';
    font-size: 16px;
    color: #333;
    cursor: pointer;
    padding: 8px 16px;
    
    &:active {
      background-color: #f5f5f5;
    }
    
    @media (max-width: 768px) {
      padding: 12px 16px; /* Larger touch target */
      font-size: 16px;
    }
  }

  .react-select__option--is-selected {
    background-color: #f5f5f5;
    color: #333;
  }

  .react-select__option--is-focused {
    background-color: #f5f5f5;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    color: #bbb;
    
    &:hover {
      color: #666;
    }
  }
`;

const TagColorDot = styled('span')`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #E0E0E0;
  background: ${(props) => props.color || '#FFFFFF'};
  flex-shrink: 0;
`;

const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 40px;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 32px;
    gap: 10px;
  }

  @media (max-width: 480px) {
    margin-top: 24px;
    gap: 8px;
  }
`;

const Button = styled('button')`
  width: 100%;
  padding: 8px 24px;
  border-radius: 4px;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  ${(props) => (props.variant === 'primary' ? `
    background: #444;
    color: white;
    &:hover {
      background: #555;
    }
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  ` : `
    background: white;
    color: #444;
    border: 1px solid #ddd;
    &:hover {
      background: #f5f5f5;
    }
  `)}

  @media (max-width: 768px) {
    padding: 12px 24px;
    font-size: 14px;
    min-height: 48px; /* Larger touch target */
  }

  @media (max-width: 480px) {
    padding: 10px 20px;
    font-size: 13px;
    min-height: 44px;
  }
`;

const MenuList = (props) => {
  const { children, maxHeight } = props;
  const listRef = useRef({});
  const rowHeights = useRef({});
  /** Calculate height based on the children length or a default */
  const childrenLengthBy40 = children?.length ? children.length * 40 : 40;
  const height = Math.min(childrenLengthBy40, maxHeight);
  const getRowHeight = (index) => rowHeights.current[index] + 8 || 40;

  return (
    <div style={{ height }}>
      {!children.length ? (
        <List
          ref={listRef}
          height={40}
          itemCount={1}
          itemSize={() => 40}
        >
          {({ style }) => (
            <div style={{
              ...style, display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
            >
              <Text fontSize='16px' color='hsl(0, 0%, 60%)'>type to create new tag</Text>
            </div>
          )}
        </List>

      ) : (
        <List
          ref={listRef}
          height={height}
          itemCount={children.length}
          itemSize={(index) => getRowHeight(index)}
        >
          {({ index, style }) => {
            const rowRef = useRef({});

            useEffect(() => {
              if (rowRef.current) {
                const rowHeight = rowRef.current.getBoundingClientRect().height;
                /** Store this index's height and reset the List after each update */
                if (rowHeights.current[index] !== rowHeight) {
                  rowHeights.current[index] = rowHeight;
                  listRef.current?.resetAfterIndex(index); /** Reset from this index to recalculate sizes */
                }
              }
            }, [index]);

            return (
              <div style={style}>
                <div ref={rowRef}>
                  {children[index]}
                </div>
              </div>
            );
          }}
        </List>
      )}
    </div>
  );
};

const MemoizedMenuList = React.memo(MenuList);

const CalendarCreateContent = ({ isModal = false, onBack, closeModal }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [currentStep] = useState(0);
  const [isCreatingCalendar, setIsCreatingCalendar] = useState(false);
  const [formData, setFormData] = useState({
    calendarType: 'calendar', // Default to calendar type
    calendarName: '',
    parentCalendar: '',
    parentCalendarName: '',
    tags: [],
  });
  const parentCalendars = useSelector((state) => state.calendar.data.parentCalendars || []);
  const newlyCreatedProgram = useSelector((state) => state.calendar.data.newlyCreatedProgram);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const accountCode = currentUser?.accountCode;
  const selectedReduxCalendar = useSelector((state) => state.calendar.data.selectedReduxCalendar);
  const selectedReduxNonDateBasedProgram = useSelector(
    (state) => state.calendar.data.selectedReduxNonDateBasedProgram,
  );
  const isProgramTagsLoading = useSelector((state) => state.calendar.ui.isProgramTagsLoading);
  const calendarCreationError = useSelector((state) => state.calendar.data.calendarCreationError);
  const createModalProgramType = useSelector((state) => state.calendar.data.createModalProgramType);
  const tagsForAllPrograms = useSelector((state) => state.calendar.data.tagsForAllPrograms);
  const [inputValue, setInputValue] = useState(null);
  const [isNewTagOptionLoading, setIsNewTagOptionLoading] = useState(false);

  /** make sure tags always get put in alphabetically order
   * becuase we can make new tags in the dropdown */
  const memoizedTagOptions = useMemo(
    () => [...tagsForAllPrograms]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((tag) => ({
        ...tag,
        avatar: tag.color && tag.color !== '#FFFFFF'
          ? <TagColorDot color={tag.color} />
          : undefined,
        avatarRight: true,
      })),
    [tagsForAllPrograms],
  );

  // Sync program type from URL on mount for deep-linking support
  useEffect(() => {
    if (location.pathname.includes('/program/create')) {
      dispatch(setCreateModalProgramType('free-form-program'));
    } else if (location.pathname.includes('/calendar/create')) {
      dispatch(setCreateModalProgramType('calendar'));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (newlyCreatedProgram) {
      dispatch(fetchSavedWorkouts(accountCode));
    }
  }, [newlyCreatedProgram]);

  const selectedCalendar = (createModalProgramType === 'calendar' && selectedReduxCalendar && Object.keys(selectedReduxCalendar).length > 0)
    ? selectedReduxCalendar
    : (selectedReduxNonDateBasedProgram
      && Object.keys(selectedReduxNonDateBasedProgram).length > 0)
      ? selectedReduxNonDateBasedProgram
      : null;

  useEffect(() => {
    if (isCreatingCalendar && selectedCalendar) {
    // Calendar was successfully created and selected
      if (isModal && closeModal) {
        closeModal(); // Close modal if in modal context
      } else {
        history.push('/build'); // Navigate if not in modal
      }
    }
  }, [
    selectedReduxCalendar,
    selectedReduxNonDateBasedProgram, // add this dependency
    isCreatingCalendar,
    history,
    isModal,
    closeModal,
  ]);

  // Watch for calendar creation errors and display toast
  useEffect(() => {
    if (isCreatingCalendar && calendarCreationError) {
      // Extract error message from the error object
      let errorMessage = 'Failed to create calendar. Please try again.';

      if (calendarCreationError) {
        errorMessage = calendarCreationError;
      }

      showErrorToast(errorMessage);

      // Reset the creating flag so user can try again
      setIsCreatingCalendar(false);
    }
  }, [calendarCreationError, isCreatingCalendar]);

  const steps = [
    {
      id: createModalProgramType === 'free-form-program' ? 'program-details' : 'calendar-details',
      title: createModalProgramType === 'free-form-program' ? 'Create New Program' : 'Calendar Details',
      component: 'CalendarDetailsForm',
    },
  ];

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCancel = () => {
    if (isModal && onBack) {
      onBack(); // Go back to previous slide in modal
      if (createModalProgramType === 'free-form-program') {
        dispatch(setCreateModalProgramType('calendar'));
      }
    } else {
      history.push('/build'); // Navigate away if not in modal
    }
  };

  const handleSave = () => {
    if (!currentUser?.accountCode) {
      return;
    }

    // Set flag to indicate calendar creation is in progress
    setIsCreatingCalendar(true);

    if (createModalProgramType === 'calendar') {
      dispatch(setProgramType('calendar'));
      const requestBody = {
        name: formData.calendarName,
        workoutVisibility: 0, // Default to "All" (value 0)
      };

      // Check if parent calendar is selected
      const hasParent = formData.parentCalendar
      && formData.parentCalendar !== '';

      if (hasParent) {
      // Call createParentChildCalendar
        requestBody.parentId = parseInt(formData.parentCalendar, 10);
        requestBody.parentName = formData.parentCalendarName;
        dispatch(createParentChildCalendar({
          accountCode: currentUser.accountCode,
          ...requestBody,
        }));
      } else {
      // Call createParentCalendar
        dispatch(createParentCalendar({
          accountCode: currentUser.accountCode,
          ...requestBody,
        }));
      }
    }
    if (createModalProgramType === 'free-form-program') {
      dispatch(setProgramType('free-form-program'));
      const requestBody = {
        programName: formData.calendarName,
        numberOfDays: 1,
        saveInfoTagIds: formData.tags,
      };
      dispatch(createSavedWorkout(accountCode, {
        ...requestBody,
      }));
    }
  };

  const isFormValid = () => formData.calendarName.trim() !== '';

  const getCalendarOptions = () => {
    const options = [
      { value: '', label: 'Select a calendar' },
    ];

    if (parentCalendars && parentCalendars.length > 0) {
      parentCalendars.forEach((calendar) => {
        options.push({
          value: calendar.id,
          label: calendar.name,
        });
      });
    }

    return options;
  };

  const getSelectedCalendarOption = () => {
    const options = getCalendarOptions();
    return options.find((option) => option.value === formData.parentCalendar) || null;
  };

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      background: 'white',
      borderColor: state.isFocused ? 'lightgray' : 'lightgray',
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'lightgray' : 'lightgray',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '4px',
      borderRadius: '4px',
      backgroundColor: 'white',
      color: state.isSelected ? '#BDBDBD' : '#444444',
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      marginBottom: '8px',
      fontWeight: state.data.__isNew__ ? 700 : 400,
      '&:hover': {
        backgroundColor: '#FCFCFC',
      },
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: '#FCFCFC',
      border: '1px solid #EEEEEE',
      borderRadius: '4px',
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: '#444444',
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: '#9E9E9E',
    }),
    menu: (provided) => ({
      ...provided,
      border: '0px',
      minWidth: '250px',
      padding: '16px',
      marginTop: '0px',
      marginBottom: '0px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9E9E9E',
    }),
    input: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? 'inherit' : provided.color, /** Use 'inherit' to maintain original color */
    }),
  };

  const renderCurrentStep = () => (
    <>
      <FormGroup>
        {createModalProgramType === 'free-form-program' ? (
          <Label>Program Name</Label>
        ) : (
          <Label>Calendar Name</Label>
        )}
        <Input
          type='text'
          value={formData.calendarName}
          onChange={(e) => handleInputChange('calendarName', e.target.value)}
          placeholder={createModalProgramType === 'free-form-program' ? 'Program name' : 'Calendar name'}
        />
      </FormGroup>
      {createModalProgramType === 'free-form-program' && (
        <SelectBox
          isDisabled={isNewTagOptionLoading || isProgramTagsLoading}
          options={memoizedTagOptions}
          value={formData.tags?.map((tagId) => memoizedTagOptions.find(
            (option) => option.id === tagId,
          )) || []}
          onInputChange={(value) => setInputValue(value)}
          onChangeFunction={(selectedOptions) => {
            /** Extract tag IDs from the selected options */
            const selectedTagIds = (selectedOptions || []).map((option) => option.id);
            /* Update the 'tags' field in the form */
            handleInputChange('tags', selectedTagIds);
          }}
          title='Tags (optional)'
          titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
          customStyles={customSelectStyles}
          isMulti
          isCreateable
          isLoading={isNewTagOptionLoading || isProgramTagsLoading}
          onCreateOption={(option) => {
            setIsNewTagOptionLoading(true);
            dispatch(createProgramTag(accountCode, option, {
              onSuccess: (response) => {
                const newOptionReturnedFromApi = { name: response.name, id: response.id };
                setFormData((prev) => ({
                  ...prev,
                  tags: [...(prev.tags || []), newOptionReturnedFromApi.id],
                }));
                setIsNewTagOptionLoading(false);
              },
              onError: () => {
                showErrorToast('Opps! Something went wrong. Unable to create new tag.');
                setIsNewTagOptionLoading(false);
              },
            }));
          }}
          noOptionsMessage={!inputValue ? 'Type to add new tag' : 'type to create new tag'}
          menuListComponent={MemoizedMenuList}
        />
      )}

      {createModalProgramType !== 'free-form-program' && (
      <FormGroup>
        <Label>Parent Calendar</Label>
        <SelectContainer>
          <Select
            value={getSelectedCalendarOption()}
            onChange={(selectedOption) => {
              if (selectedOption) {
                handleInputChange('parentCalendar', selectedOption.value);
                handleInputChange('parentCalendarName', selectedOption.label);
              } else {
                // Clear both when selection is removed
                handleInputChange('parentCalendar', '');
                handleInputChange('parentCalendarName', '');
              }
            }}
            options={getCalendarOptions()}
            className='react-select'
            classNamePrefix='react-select'
            placeholder='Select a calendar'
            isSearchable
            isClearable
          />
        </SelectContainer>
      </FormGroup>
      )}
    </>
  );

  const currentStepData = steps[currentStep];

  return (
    <Container isModal={isModal}>
      <ContentWrapper isModal={isModal}>
        <Breadcrumbs>
          <BreadcrumbButton
            onClick={isModal ? (onBack || undefined) : () => history.push('/build')}
            disabled={isModal && !onBack}
          >
            Program Type
          </BreadcrumbButton>
          <BreadcrumbSeparator>/</BreadcrumbSeparator>
          {createModalProgramType === 'free-form-program' ? 'Program Details' : 'Calendar Details'}
        </Breadcrumbs>
        <Title>{currentStepData.title}</Title>
        {createModalProgramType !== 'free-form-program' && (
        <Subtitle>
          Provide the basic details for the calendar.
        </Subtitle>
        )}

        {renderCurrentStep()}

        <ButtonContainer>
          <Button variant='secondary' onClick={handleCancel}>
            Back
          </Button>
          <Button
            variant='primary'
            onClick={handleSave}
            disabled={!isFormValid()}
          >
            Save
          </Button>
        </ButtonContainer>
      </ContentWrapper>
    </Container>
  );
};

CalendarCreateContent.propTypes = {
  isModal: PropTypes.bool,
  onBack: PropTypes.func,
  closeModal: PropTypes.func,
};

CalendarCreateContent.defaultProps = {
  isModal: false,
  onBack: null,
  closeModal: null,
};

export default CalendarCreateContent;
